const minicartBody = {
    MinicartBody: {
        baseStyle: () => ({
            wrapper: {
                w: 'full',
                gap: '0',
                h: 'full',
            },
            titleWrapper: {
                w: 'full',
                textAlign: 'center',
                pb: {base: 'spacing.2', xl: 'spacing.5'},
            },
            title: {
                textStyle: 'displayMd',
            },
        }),
    },
}

export default minicartBody
